var map = {
	"./AE.svg": "2IhB",
	"./AF.svg": "TauI",
	"./AT.svg": "WSBM",
	"./AU.svg": "Bb4m",
	"./BE.svg": "ukDl",
	"./BH.svg": "/fc8",
	"./BR.svg": "KUQS",
	"./CA.svg": "nAou",
	"./CH.svg": "zkZ7",
	"./CY.svg": "Dlm7",
	"./CZ.svg": "e8ag",
	"./DE.svg": "FMSA",
	"./EG.svg": "vgOi",
	"./ES.svg": "YV+1",
	"./EU.svg": "2ktR",
	"./FR.svg": "Q2tC",
	"./GB.svg": "GigF",
	"./ID.svg": "7QIk",
	"./IE.svg": "9sHu",
	"./IN.svg": "TRJg",
	"./IT.svg": "bQuo",
	"./JP.svg": "sGB/",
	"./KR.svg": "I/nG",
	"./MX.svg": "L2j/",
	"./MY.svg": "R/T+",
	"./NL.svg": "OLXi",
	"./PH.svg": "vW6Y",
	"./PL.svg": "2iZa",
	"./QT.svg": "iIbn",
	"./SA.svg": "Y9GJ",
	"./SE.svg": "hhx1",
	"./SG.svg": "UbaJ",
	"./TH.svg": "dJ24",
	"./US.svg": "tCT3",
	"./VN.svg": "UVXj",
	"./VNM.svg": "Kt1g"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jUyi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag ^\.\/.*\.svg$
// module id = jUyi
// module chunks = 55